import { render, staticRenderFns } from "./reportLayout.vue?vue&type=template&id=61ed7af0&"
import script from "./reportLayout.vue?vue&type=script&lang=ts&"
export * from "./reportLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports